/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.ActionToRoleResource = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ActionToRoleResource model module.
   * @module model/ActionToRoleResource
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>ActionToRoleResource</code>.
   * A resource that includes a ID of role and an action.
   * @alias module:model/ActionToRoleResource
   * @class
   * @param roleId {String} The ID of the role.
   * @param action {String} The action you want to assign to the role.
   */
  var exports = function(roleId, action) {
    var _this = this;

    _this['roleId'] = roleId;
    _this['action'] = action;
  };

  /**
   * Constructs a <code>ActionToRoleResource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ActionToRoleResource} obj Optional instance to populate.
   * @return {module:model/ActionToRoleResource} The populated <code>ActionToRoleResource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('roleId')) {
        obj['roleId'] = ApiClient.convertToType(data['roleId'], 'String');
      }
      if (data.hasOwnProperty('action')) {
        obj['action'] = ApiClient.convertToType(data['action'], 'String');
      }
    }
    return obj;
  }

  /**
   * The ID of the role.
   * @member {String} roleId
   */
  exports.prototype['roleId'] = undefined;
  /**
   * The action you want to assign to the role.
   * @member {String} action
   */
  exports.prototype['action'] = undefined;



  return exports;
}));



